interface SkeletonProps {
  w?: number
  h: number
  round?: boolean
  inside?: boolean
  style?: string
  children?: React.ReactNode
}

export default function Skeleton({
  w,
  h,
  round = false,
  inside = false,
  style,
  children,
}: SkeletonProps) {
  return (
    <div
      style={{ height: `${h}px`, width: w ? `${w}px` : undefined }}
      className={`animate-pulse ${round ? "rounded-full" : "rounded-xl"} ${
        inside ? "bg-modal" : "bg-card"
      } ${style}`}
    >
      {children}
    </div>
  )
}
